export const tableBreak = {
  tiny: '(max-width: 410px)',
  small: '(max-width: 625px)',
  medium: '(max-width: 1155px)',
  large: '(max-width: 1550px)',
  huge: '(max-width: 1780px)',
}
